import { z } from 'zod';
import type {
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
  UseFormTrigger,
} from 'react-hook-form';


const assignScheduleBaseSchema = z.object({
  schedule1Id: z.union([
    z.coerce.number().int().positive(),
    z.null(),
  ]),
  schedule2Id: z.union([
    z.coerce.number().int().positive(),
    z.null(),
  ]).optional().default(null),
  replicateDaySequences: z.array(z.number().int().positive()).optional().default([]),
});

export const assignScheduleSchema = assignScheduleBaseSchema.superRefine((data, ctx) => {
  if (data.schedule1Id === null) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'schedule:shift.create.assignSchedule.validation.schedule1Required',
      path: ['schedule1Id'],
    });
  }
});

export type AssignScheduleForm = z.infer<typeof assignScheduleSchema>;

export interface AssignScheduleFormSubset {
  register: UseFormRegister<AssignScheduleForm>;
  setValue: UseFormSetValue<AssignScheduleForm>;
  watch: UseFormWatch<AssignScheduleForm>;
  errors: FieldErrors<AssignScheduleForm>;
  trigger: UseFormTrigger<AssignScheduleForm>;
}
